import { render, staticRenderFns } from "./ExportXlsxModal.vue?vue&type=template&id=3b3ca852&"
import script from "./ExportXlsxModal.vue?vue&type=script&lang=js&"
export * from "./ExportXlsxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports